module.exports = __webpack_public_path__ + "img/80.2f49d7e4.jpg";